var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRIconCoOwnership(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "R_Icon_Co-Ownership") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets-\\u2013-Iconography",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R_Icon_Co-Ownership"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container",
    opacity: 0,
    fill: "#DDDDDD"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(2, 4)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow",
    transform: "translate(7.1111, 6.8571)",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "2.66666667 0 0 2.57142857 2.66666667 5.14285714"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.33333333,
    y1: 2.57142857,
    x2: 2.51650552e-15,
    y2: 2.57142857,
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Arrow",
    transform: "translate(3.5556, 0)",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "2.66666667 0 5.33333333 2.57142857 2.66666667 5.14285714"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.33333333,
    y1: 2.57142857,
    x2: 2.51650552e-15,
    y2: 2.57142857,
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.4444444,9.42857143 C14.4081236,9.42857143 16,7.89354771 16,6 C16,4.10645229 14.4081236,2.57142857 12.4444444,2.57142857",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55555556,2.57142857 C1.59187645,2.57142857 0,4.10645229 0,6 C0,7.89354771 1.59187645,9.42857143 3.55555556,9.42857143",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRIconCoOwnership);
export default __webpack_public_path__ + "static/media/R_Icon_Co-Ownership.7d07aff404f3a85db0b38b23db563950.svg";
export { ForwardRef as ReactComponent };